export enum ReportAudience {
  Company = 'Company',
  Participant = 'Participant'
}
